import {
  GET_CANCEL_PLAN,
  GET_CANCEL_PLAN_SUCCESS,
  GET_CANCEL_PLAN_FAILURE,
} from 'store/cancelSubscription/cancelSubscriptionAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const postCancelReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CANCEL_PLAN:
      return { ...state, loading: true };
    case GET_CANCEL_PLAN_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_CANCEL_PLAN_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default postCancelReducer;
